import styled from 'styled-components';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';

export const Divider = styled(HorizontalSeparator)`
  margin-bottom: 20px;
`;

export const HeaderWrapper = styled.div`
  padding: 60px 0 20px 0;
`;

export const Title = styled.div`
  margin-bottom: 10px;
`;

export const NewConversationScreenContainer = styled.div`
  width: 580px;
  margin: 0 auto;
  color: ${({ theme }) => theme.colors.gray};
`;

export const PremiumBadgeWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
`;
